import { OfferNotActualAnymore } from 'pages/candidateOffer/components';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import { offerSelector } from '../../store';
import ConfirmationPage from './ConfirmationPage';

function ConfirmationPageGuard() {
    const offer = useSelector(offerSelector);

    if (!offer || (!offer.periods?.length && !offer.shifts?.length)) {
        return <OfferNotActualAnymore />;
    }

    return <ConfirmationPage offer={ offer } />;
}

export default memo(ConfirmationPageGuard);
